import { SsoRoleMapping } from '@choco-admin/types';

import { useSsoPageRoleMappingsQuery } from '../../../generated';
import { mapToSsoRoleMappings } from '../utils';

export interface UseSsoRoleMappingsInput {
  connectionId: string;
}

export interface UseSsoRoleMappingsResult {
  roleMappings: SsoRoleMapping[];
  /** The read carries no validation member, so a blank id answers not found. */
  notFound: boolean;
  isLoading: boolean;
  error: Error | null;
  refetch: () => void;
}

export const useSsoRoleMappings = ({
  connectionId,
}: UseSsoRoleMappingsInput): UseSsoRoleMappingsResult => {
  const { data, loading, error, refetch } = useSsoPageRoleMappingsQuery({
    variables: { input: { connectionId } },
    fetchPolicy: 'cache-and-network',
    skip: !connectionId,
  });

  const result = data?.ssoRoleMappings;

  const authorizationError =
    result?.__typename === 'AuthorizationFailure'
      ? new Error(result.message ?? 'Not authorized to view role mappings.')
      : null;

  return {
    roleMappings:
      result?.__typename === 'SsoRoleMappingList'
        ? mapToSsoRoleMappings(result.roleMappings)
        : [],
    notFound: result?.__typename === 'NotFoundError',
    isLoading: loading,
    error: error ?? authorizationError,
    refetch: () => {
      refetch();
    },
  };
};
